import { get } from '@alltrails/shared/api';
import CountryCode from 'types/CountryCode';
import { external } from './schema';

type AvailablePlansResponse = external['available_plans_response.yaml'];

// eslint-disable-next-line import/prefer-default-export
export async function getAvailablePlans(billingCountry: CountryCode) {
  const params = new URLSearchParams();
  params.set('billing_country', billingCountry);

  return get<AvailablePlansResponse>(`/api/alltrails/purchases/available_plans?${params.toString()}`);
}
